// @ts-nocheck

import { createSelector } from 'reselect';

import { type StateType } from '../../../states';
import { KLUserStatuses } from '../types/user';

const emptyObj = {};

export const selectKLGlobalState = createSelector(
  [(state: StateType) => state.kl.global ?? emptyObj],
  (globalState) => globalState,
);

export const selectKLGlobalStatus = createSelector(
  selectKLGlobalState,
  (globalState) => globalState.status ?? KLUserStatuses.OFF,
);

export const selectKLGlobalVersion = createSelector(selectKLGlobalState, (globalState) => globalState.version);

export const selectKLGlobalRace = createSelector(selectKLGlobalState, (globalState) => globalState.race);

export const selectKLGlobalCriteria = createSelector(
  selectKLGlobalState,
  (globalState) => globalState.criteria ?? emptyObj,
);

export const selectKLOperationEndDate = createSelector(
  selectKLGlobalState,
  (globalState) => globalState.operationEndDate,
);
